import { toast } from "react-toastify";
import {
  clearMarkers,
  handleCountrySelectedGeometry,
  handleStateGridLatLng,
  handleStateData,
  handleStateSelectedGeometry,
  handleStateViewData,
  handleStoreDistrictGrids,
  handleStoreMarkers,
  handleStoreStateGridView,
  hasError,
  startLoading,
  stopLoading,
  handleCropData,
  handlePOSPCount,
  handlePOSPTarget,
  setComputedDate,
} from "../redux/slices/mapApiSlice.ts";
import { method, paths } from "../services/ServiceConstants.tsx";
import ServicesManagerAPICall from "../services/ServicesManagerAPICall.tsx";
import { handleAuthentication } from "../redux/slices/loginApiSlice.ts";
import { checkTokenMessage } from "./CountryAPI.tsx";
import { ACTIVE_VIEW_COUNTRY } from "../utils/Constants.tsx";
import { handleCountryGridLatLng } from "../redux/slices/countryApiSlice.ts";
import axios from "axios";

export const getStateData = (params) => {
  return async (dispatch: any) => {
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.STATE_VIEW_DATA_V2,
        params,
        true,
        false,
      ).then(
        async (res: any) => {
          if (checkTokenMessage(res)) {
            dispatch(handleAuthentication({}));
          } else if (res) {
            dispatch(handleStateViewData(res));
          }
        },
        (err: any) => {
          toast("Unable to fetch data, please try again later");
        },
      );
    } catch (error) {
      toast("Unable to fetch data, please try again later");
    }
  };
};
const getConsolidatedEndPoint = (params: any) => {
  if (params?.sid && params?.did) {
    return paths.CONSOLIDATED_BUSINESS_GRID_WISE;
  } else if (params?.sid && !params?.did) {
    return paths.CONSOLIDATED_BUSINESS_DISTRICT_WISE;
  } else {
    return paths.CONSOLIDATED_BUSINESS_STATE_WISE;
  }
};
export const getConsolidatedData = (params: any) => {
  return async (dispatch: any) => {
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        getConsolidatedEndPoint(params),
        params,
        true,
        false,
      ).then(
        async (res: any) => {
          if (checkTokenMessage(res)) {
            dispatch(handleAuthentication({}));
          } else if (res) {
            dispatch(handleStateViewData(res));
          }
        },
        (err: any) => {
          toast("Unable to fetch data, please try again later");
        },
      );
    } catch (error) {
      toast("Unable to fetch data, please try again later");
    }
  };
};
export const getConsolidatedManPower = (params) => {
  return async (dispatch: any) => {
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.CONSOLIDATED_MAN_POWER,
        params,
        true,
        false,
      ).then(
        async (res: any) => {
          if (checkTokenMessage(res)) {
            dispatch(handleAuthentication({}));
          } else if (res) {
            const result = res;
            result.isPosp = true;
            dispatch(handleStateViewData(result));
          }
        },
        (err: any) => {
          toast("Unable to fetch data, please try again later");
        },
      );
    } catch (error) {
      toast("Unable to fetch data, please try again later");
    }
  };
};

export const getPOSPTargetData = (params) => {
  return async (dispatch: any) => {
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.STATE_VIEW_DATA_V2,
        params,
        true,
        false,
      ).then(
        async (res: any) => {
          if (checkTokenMessage(res)) {
            dispatch(handleAuthentication({}));
          } else if (res) {
            dispatch(handlePOSPTarget(res));
          }
        },
        (err: any) => {
          toast("Unable to fetch data, please try again later");
        },
      );
    } catch (error) {
      toast("Unable to fetch data, please try again later");
    }
  };
};
export const getCropData = (params) => {
  return async (dispatch: any) => {
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.NOC_CROP_METRICS,
        params,
        true,
        false,
      ).then(
        async (res: any) => {
          if (checkTokenMessage(res)) {
            dispatch(handleAuthentication({}));
          } else if (res) {
            dispatch(handleCropData(res));
          }
        },
        (err: any) => {
          toast("Unable to fetch data, please try again later");
        },
      );
    } catch (error) {
      toast("Unable to fetch data, please try again later");
    }
  };
};
export const getPOSPCount = (params) => {
  return async (dispatch: any) => {
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.NOC_CROP_METRICS,
        params,
        true,
        false,
      ).then(
        async (res: any) => {
          if (checkTokenMessage(res)) {
            dispatch(handleAuthentication({}));
          } else if (res) {
            dispatch(handlePOSPCount(res));
          }
        },
        (err: any) => {
          toast("Unable to fetch data, please try again later");
        },
      );
    } catch (error) {
      toast("Unable to fetch data, please try again later");
    }
  };
};
export const getSelectedGeometry = (data, activeView) => {
  return async (dispatch: any) => {
    if (activeView === ACTIVE_VIEW_COUNTRY) {
      dispatch(handleCountrySelectedGeometry(null));
    } else {
      dispatch(handleStateSelectedGeometry(null));
    }
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.GRID_GEOMETRY,
        data,
        true,
        true,
      ).then(
        async (res: any) => {
          if (checkTokenMessage(res)) {
            dispatch(handleAuthentication({}));
          } else if (res) {
            dispatch(handleStateSelectedGeometry(res));
            // if (activeView === ACTIVE_VIEW_COUNTRY) {
            //   dispatch(handleCountrySelectedGeometry(res));
            // } else {
            //   dispatch(handleStateSelectedGeometry(res));
            // }
          }
        },
        (err: any) => {},
      );
    } catch (error) {}
  };
};
export const getGridLatLng = (data, activeView) => {
  return async (dispatch: any) => {
    // if (activeView === ACTIVE_VIEW_COUNTRY) {
    //   dispatch(handleCountryGridLatLng(null));
    // } else {
    //   dispatch(handleStateGridLatLng(null));
    // }
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.GRID_LAT_LNG,
        data,
        true,
        false,
      ).then(
        async (res: any) => {
          if (checkTokenMessage(res)) {
            dispatch(handleAuthentication({}));
          } else if (res) {
            console.log(res, "res");

            dispatch(handleStateGridLatLng(res));
            // if (activeView === ACTIVE_VIEW_COUNTRY) {
            //   dispatch(handleCountryGridLatLng(res));
            // } else {
            //   dispatch(handleStateGridLatLng(res));
            // }
          }
        },
        (err: any) => {},
      );
    } catch (error) {}
  };
};
export const getStateGridView = (state: string) => {
  const data = {
    state: state,
  };
  return async (dispatch: any) => {
    dispatch(startLoading());
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.STATE_GRID_VIEW,
        data,
        true,
        true,
      ).then(
        async (res: any) => {
          if (res != null) {
            if (checkTokenMessage(res)) {
              dispatch(handleAuthentication({}));
            } else {
              dispatch(handleStoreStateGridView(res));
            }
          } else {
            toast("Unable to fetch data, please try again later");
          }
        },
        (err: any) => {
          dispatch(stopLoading());
          dispatch(handleStoreStateGridView({}));
          toast("Unable to fetch data, please try again later");
        },
      );
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};
export const getDistrictPolygon = (district: string) => {
  const data = {
    district: district,
  };
  return async (dispatch: any) => {
    dispatch(startLoading());
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.DISTRICT_GRID_VIEW,
        data,
        true,
        true,
      ).then(
        async (res: any) => {
          if (res != null) {
            if (checkTokenMessage(res)) {
              dispatch(handleAuthentication({}));
            } else {
              dispatch(handleStoreStateGridView(res));
            }
          } else {
            toast("Unable to fetch data, please try again later");
          }
        },
        (err: any) => {
          dispatch(stopLoading());
          dispatch(handleStoreStateGridView({}));
          toast("Unable to fetch data, please try again later");
        },
      );
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};

export const getMarkersByState = (state: string, marker: string) => {
  const data = {
    state: state,
  };
  return async (dispatch: any) => {
    dispatch(startLoading());
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        "/" + marker,
        data,
        true,
        true,
      ).then(
        async (res: any) => {
          if (res != null) {
            if (checkTokenMessage(res)) {
              dispatch(handleAuthentication({}));
            } else {
              dispatch(handleStoreMarkers({ marker: marker, res: res }));
              dispatch(handleStateData(res));
            }
          } else {
            toast("Unable to fetch data, please try again later");
          }
        },
        (err: any) => {
          dispatch(stopLoading());
          dispatch(clearMarkers());
          toast("Unable to fetch data, please try again later");
        },
      );
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};

export const getMarkersByDistrict = (district: string, marker: string) => {
  const data = {
    district: district,
  };
  return async (dispatch: any) => {
    dispatch(startLoading());
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        "/" + marker + paths.DISTRICT,
        data,
        true,
        true,
      ).then(
        async (res: any) => {
          if (res != null) {
            if (checkTokenMessage(res)) {
              dispatch(handleAuthentication({}));
            } else {
              dispatch(handleStoreMarkers({ marker: marker, res: res }));
              dispatch(handleStateData(res));
            }
          } else {
            toast("Unable to fetch data, please try again later");
          }
        },
        (err: any) => {
          dispatch(stopLoading());
          dispatch(clearMarkers());
          toast("Unable to fetch data, please try again later");
        },
      );
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};

export const getGridsByDistrict = (district: string) => {
  const data = {
    district: district,
  };

  return async (dispatch: any) => {
    dispatch(startLoading());
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.DISTRICT_DATA,
        data,
        true,
        true,
      ).then(
        async (res: any) => {
          if (res != null) {
            if (checkTokenMessage(res)) {
              dispatch(handleAuthentication({}));
            } else {
              dispatch(handleStoreDistrictGrids(res));
            }
          } else {
            toast("Unable to fetch data, please try again later");
          }
        },
        (err: any) => {
          dispatch(stopLoading());
          dispatch(handleStoreDistrictGrids({}));
          toast("Unable to fetch data, please try again later");
        },
      );
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};

export const getPOSPMarkersByGrid = (
  distance: number,
  latitude: any,
  longitude: any,
) => {
  const data = {
    longitude: longitude,
    latitude: latitude,
    distance: distance,
  };
  return async (dispatch: any) => {
    dispatch(startLoading());
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.POSP_GRID_DISTANCE,
        data,
        true,
        true,
      ).then(
        async (res: any) => {
          if (res != null) {
            if (checkTokenMessage(res)) {
              dispatch(handleAuthentication({}));
            } else {
              dispatch(handleStoreMarkers({ marker: "posps", res: res }));
              dispatch(handleStateData(res));
            }
          } else {
            toast("Unable to fetch data, please try again later");
          }
        },
        (err: any) => {
          dispatch(stopLoading());
          dispatch(clearMarkers());
          toast("Unable to fetch data, please try again later");
        },
      );
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};

export const getUniversityMarkersByGrid = (
  distance: number,
  latitude: any,
  longitude: any,
) => {
  const data = {
    longitude: longitude,
    latitude: latitude,
    distance: distance,
  };
  return async (dispatch: any) => {
    dispatch(startLoading());
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.UNIVERSITY_GRID_DISTANCE,
        data,
        true,
        true,
      ).then(
        async (res: any) => {
          if (res != null) {
            if (checkTokenMessage(res)) {
              dispatch(handleAuthentication({}));
            } else {
              dispatch(
                handleStoreMarkers({ marker: "universities", res: res }),
              );
              dispatch(handleStateData(res));
            }
          } else {
            toast("Unable to fetch data, please try again later");
          }
        },
        (err: any) => {
          dispatch(stopLoading());
          dispatch(clearMarkers());
          toast("Unable to fetch data, please try again later");
        },
      );
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};

export const getComputedDate = () => {
  const params = {
    dataType: "FORECAST",
    source: "ECMWF",
    locType: "KSHEMA_0.065",
  };
  return async (dispatch: any) => {
    dispatch(startLoading());
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.LATEST_COMPUTED_DATE,
        params,
        false,
        false,
        paths.WEATHER_MANAGEMENT,
      ).then(
        async (res: any) => {
          dispatch(setComputedDate(res));
        },
        (err: any) => {
          dispatch(setComputedDate({ data: null }));
        },
      );
    } catch (error) {
      dispatch(setComputedDate({ data: null }));
    }
  };
};
